import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../const";
// import { createBrowserHistory } from 'history'
import _ from "lodash";
import { Service } from "../service/service";
import Cookies from "universal-cookie";
const LOG_IN = "LOG_IN";
const LOG_IN_PENDING = "LOG_IN_PENDING";
const LOG_IN_REJECTED = "LOG_IN_REJECTED";
const LOG_IN_FULFILLED = "LOG_IN_FULFILLED";

const CREATE_CRECHE = "CREATE_CRECHE";

const GET_ACCOUNT = "GET_ACCOUNT";

const LOG_OUT = "LOG_OUT";

const CREATE_CRECHE_PENDING = "CREATE_CRECHE_PENDING";
const CREATE_CRECHE_REJECTED = "CREATE_CRECHE_REJECTED";
const CREATE_CRECHE_FULFILLED = "CREATE_CRECHE_FULFILLED";

const GET_ACCOUNT_PENDING = "GET_ACCOUNT_PENDING";
const GET_ACCOUNT_REJECTED = "GET_ACCOUNT_REJECTED";
const GET_ACCOUNT_FULFILLED = "GET_ACCOUNT_FULFILLED";

const RESET_PASS_Token_PENDING = "RESET_PASS_Token_PENDING";
const RESET_PASS_Token_REJECTED = "RESET_PASS_Token_REJECTED";
const RESET_PASS_Token_FULFILLED = "RESET_PASS_Token_FULFILLED";

const RESET_PASS_PENDING = "RESET_PASS_PENDING";
const RESET_PASS_REJECTED = "RESET_PASS_REJECTED";
const RESET_PASS_FULFILLED = "RESET_PASS_FULFILLED";

const LOG_OUT_FULFILLED = "LOG_OUT_FULFILLED";
const LOG_OUT_REJECTED = "LOG_OUT_REJECTED";
const LOG_IN_ERROR = "LOG_IN_ERROR";
const LOG_IN_ERROR_RESET = "LOG_IN_ERROR_RESET";
const UN_AUTHORIZED_REDIRECT = "UN_AUTHORIZED_REDIRECT";
const TOKEN_SET_FULFILLED = "TOKEN_SET_FULFILLED";

const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";

var querystring = require("querystring");

const loading = (state = false, { type }) => {
  switch (type) {
    case LOG_IN_PENDING:
    case CREATE_CRECHE_PENDING:
    case GET_ACCOUNT_PENDING:
      return true;
    case LOG_IN_REJECTED:
    case LOG_IN_FULFILLED:
    case CREATE_CRECHE_REJECTED:
    case CREATE_CRECHE_FULFILLED:
    case GET_ACCOUNT_REJECTED:
    case GET_ACCOUNT_FULFILLED:
      return false;
    default:
      return state;
  }
};

const account = (state = null, { type, payload }) => {
  switch (type) {
    case GET_ACCOUNT_PENDING:
    case GET_ACCOUNT_REJECTED:
      return null;
    case GET_ACCOUNT_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;
    default:
      return state;
  }
};

const isRedirectPassword = (state = false, { type, payload }) => {
  switch (type) {
    case RESET_PASS_Token_PENDING:
    case RESET_PASS_Token_REJECTED:
      return false;
    case RESET_PASS_Token_FULFILLED:
      return true;
    default:
      return state;
  }
};

const error = (state = null, { type, payload }) => {
  switch (type) {
    case LOG_IN_PENDING:
    case LOG_IN_FULFILLED:
    case LOG_OUT:
    case LOG_IN_ERROR_RESET:
    case RESET_PASS_Token_PENDING:
    case RESET_PASS_Token_FULFILLED:
      return null;
    case LOG_IN_REJECTED:
    case LOG_IN_ERROR:
    case RESET_PASS_Token_REJECTED:
    case RESET_PASS_REJECTED:
      return payload;
    default:
      return state;
  }
};

const accessToken = (state = null, { type, payload }) => {
  switch (type) {
    case LOG_IN_FULFILLED: {
      if (payload.data.token) {
        let token = payload.data.token;
        let decoded = token.match("access_token=(.*)&token_type");
        return decoded[1];
      } else {
        return null;
      }
    }
    case LOG_IN:
    case LOG_OUT_FULFILLED:
    case LOG_IN_PENDING:
    case LOG_IN_REJECTED:
    case LOG_OUT:
    case UN_AUTHORIZED_REDIRECT:
      return null;
    case TOKEN_SET_FULFILLED:
      return payload.data.token;
    default:
      return state;
  }
};

const creche = (state = null, { type, payload }) => {
  switch (type) {
    case CREATE_CRECHE_FULFILLED:
      return payload.data;
    default:
      return state;
  }
};

export const login = (credentials) => ({
  type: LOG_IN,
  payload: credentials,
});

export const setToken = (token) => ({
  type: TOKEN_SET_FULFILLED,
  payload: { data: { token } },
});

export const emptyToken = (token) => ({
  type: TOKEN_SET_FULFILLED,
  payload: { data: { token } },
});

export const logout = () => {
  return (dispatch) => {
    localStorage.removeItem("token");
    localStorage.clear();
       window.location.href = `${API}api/auth/logout`;
 
  };
 };

export const errorLogin = () => ({
  type: LOG_IN_ERROR,
  payload: "Login ou mot de passe incorrect",
});
export const errorForgotPassword = (payload) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: payload,
});

export const resetLoginErrors = () => ({
  type: LOG_IN_ERROR_RESET,
});

export function unAuthorized() {
  return (dispatch) => {
    localStorage.removeItem("token");
    dispatch(logout());
    window.location.reload(true);
    fetch(
      `${API}api/auth/oauth/authorize?response_type=token&client_id=kiuono-creche&redirect_uri=${API}/creche/index.html&scope=read`,
      { Cookie: "" }
    ).then((res) => {
      dispatch({
        type: UN_AUTHORIZED_REDIRECT,
      });
    });
    window.location.href = `${API}api/auth/oauth/authorize?response_type=token&client_id=kiuono-creche&redirect_uri=${API}creche/index.html&scope=read`;
  };
}

export const createCreche = (data) => ({
  type: CREATE_CRECHE,
  payload: axios.post(`${API}api/creche/creches`, data),
});

// `auth` reducer
export default combineReducers({
  loading,
  error,
  accessToken,
  creche,
  account,
  isRedirectPassword,
});

// ################## `auth` module actions ##################
export const getAccount = (tok) => ({
  type: GET_ACCOUNT,
  payload: axios.get(`${API}api/auth/me`, {
    headers: { Authorization: `Bearer ${tok}` },
  }),
});

let config = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
};
export function loginAction(credentials) {
  return (dispatch) => {
    fetch(`${API}api/auth/oauth/token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: `grant_type=password&username=${encodeURIComponent(credentials.username)}&password=${encodeURIComponent(credentials.password)}`,
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error("login_failed");
      })
      .then((data) => {
        window.localStorage.setItem("token", data.access_token);
        window.localStorage.setItem("first", true);
        window.location.replace(
          window.location.protocol +
            "//" +
            window.location.host +
            "/creche/enfants"
        );
      })
      .catch((err) => {
        dispatch(errorLogin());
      });
  };
}

export const emailTokenResetPass = (tok, data) => {
  return (dispatch) => {
    dispatch({ type: RESET_PASS_Token_PENDING });
    const response = Service.post(
      `${API}api/auth/compte/passwords/reset/tokens`,
      data
    );
    response.then((res) => {
      dispatch({ type: RESET_PASS_Token_FULFILLED, payload: res });
      dispatch({ type: "OPEN_SNACKBAR_SUCCESS" });
    });
    response.catch((err) => {
      dispatch({ type: RESET_PASS_Token_REJECTED, payload: err });
      dispatch({ type: "OPEN_SNACKBAR_ERROR" });
      dispatch(errorForgotPassword(err.message));
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const resetPassword = (data) => {
  return (dispatch) => {
    dispatch({ type: RESET_PASS_PENDING });
    const response = Service.post(
      `${API}api/auth/compte/passwords/reset`,
      data
    );
    response.then((res) => {
      dispatch({ type: RESET_PASS_FULFILLED, payload: res });
      dispatch({ type: "OPEN_SNACKBAR_SUCCESS" });
    });
    response.catch((error) => {
      let message = !_.isEmpty(error.response)
        ? error.response.data.message
        : null;

      dispatch({ type: RESET_PASS_REJECTED, payload: error });
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });

      if (error.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
